import createSchemaUtils from "@core/helpers/createSchemaUtils";
import z from "zod";

//#region ServiceCatalogue Link Action Schemas
const ServiceCatalogueLinkReplaceStringActionSchema = z.object({
    match: z.string(),
    action: z.literal("replace-string"),
    replaceWith: z.string(),
}).describe("Replaces a matched string in the URL template with another string.");

const ServiceCatalogueExtractParamsLinkActionSchema = z.object({
    match: z.string(),
    action: z.literal("extract-params"),
    paramsMap: z.object({
        workflowId: z.string(),
        revisionId: z.string(),
    }),
}).describe("Extracts parameters from the URL template based on the matched string.");

const ServiceCatalogueLinkActionItemSchema = z.discriminatedUnion("action", [
    ServiceCatalogueLinkReplaceStringActionSchema,
    ServiceCatalogueExtractParamsLinkActionSchema,
]);
const ServiceCatalogueLinkActionListSchema = z.array(ServiceCatalogueLinkActionItemSchema);
export type ServiceCatalogueLinkActionArray = z.infer<typeof ServiceCatalogueLinkActionListSchema>;
export const ServiceCatalogueLinkActionArray = createSchemaUtils(ServiceCatalogueLinkActionListSchema);
//#endregion

//#region ServiceCatalogue API Settings Schema
const ApiSetting = z.object({
    domain: z.string().url(),
    key: z.string(),
    phrase: z.string(),
    captchaKey: z.string().optional(),
});
const ServiceCatalogueApiSettingsSchema = z.object({
    configurations: z.object({
        Fluids365: ApiSetting,
        ServiceManagement: ApiSetting,
        eds: ApiSetting,
    }),
    endpoints: z.object({
        SearchFull: z.string(),
        SearchPrediction: z.string(),
        RequestOfferingQuery: z.string(),
        Submit: z.string(),
    }),
});
export type ServiceCatalogueApiSettings = z.infer<typeof ServiceCatalogueApiSettingsSchema>;
export const ServiceCatalogueApiSettings = createSchemaUtils(ServiceCatalogueApiSettingsSchema);
//#endregion

const ServiceCatalogueSettingSchema = z.object({
    ApiSettings: ServiceCatalogueApiSettingsSchema.or(z.object({
        message: z.string(),
    })),
    LinkActions: ServiceCatalogueLinkActionListSchema,
});
export type ServiceCatalogueSetting = z.infer<typeof ServiceCatalogueSettingSchema>;

const AppSettingSchema = z.object({
    Features: z.union([
        z.literal("TeamsApp"),
    ]).array().describe("List of enabled feature flags."),
    ServiceCatalogue: ServiceCatalogueSettingSchema,
});
export type AppSettings = z.infer<typeof AppSettingSchema>;
export const AppSettingsDefault = Object.freeze<AppSettings>({
    Features: [],
    ServiceCatalogue: {
        ApiSettings: { message: "API settings not configured." },
        LinkActions: [],
    }
});